$(document).ready(function(){
	//LGEUS-298 START
	$('.request-select').change(function(){
		var ccpaRequest_val = $("#ccpa-request").val();
		var ccpaSites_val = $("#ccpa-sites").val();		
		$(".necessaryInfo_area").hide();
		$(".choice_smartTv").hide();
		$(".choice_phone").hide();
		$(".optOut_otn").hide();
		$(".request-area").hide();
		$(".intext-area").hide();
		$('.in-step-cluster .info-submit').attr('disabled',false);//LGEUS-298
		if(ccpaRequest_val == 'Information inquiry' && ccpaSites_val == 'LG Smart TV' || ccpaRequest_val == "information deletion" && ccpaSites_val == 'LG Smart TV'){
			$(".request-area").show();
			$('#btn_necessary').attr('aria-expanded','false');
			$('.in-step-cluster .info-submit').attr('disabled',true); //LGEUS-298
		} else if(ccpaRequest_val == 'Information inquiry' && ccpaSites_val == 'LG Smart phone' || ccpaRequest_val == "information deletion" && ccpaSites_val == 'LG Smart phone'){	
			$(".necessaryInfo_area").show().addClass("active");
			$(".choice_phone").show().addClass("active");
		} else if(ccpaRequest_val == "do not sell my information" && ccpaSites_val == 'LG Smart TV'){
			$(".optOut_otn").show();
		} else if(ccpaRequest_val !== '' && ccpaSites_val == 'Others (Please specify in the details below)'){	
			$(".intext-area").show();
			$('#otherError').modal('show');
		} else if( ccpaRequest_val == '' || ccpaSites_val == '' ){
			$(".necessaryInfo_area").hide();
			$(".choice_smartTv").hide();
			$(".choice_phone").hide();
			$(".optOut_otn").hide();
			$(".request-area").hide();
			$(".intext-area").hide(); 
		} else{
			$(".intext-area").show(); 
		}
	});
	$('#modalPhpop2').on('show.bs.modal', function (event){
		var button = $(event.relatedTarget);
		var recipient = button.text();
		var modal = $(this);
		modal.find('.modal-title').text(recipient);
	});
	$('#btn_necessary').click( function() {
		var ccpaRequest_val = $("#ccpa-request").val();
		var ccpaSites_val = $("#ccpa-sites").val();
		$(this).attr('aria-expanded','true');
		if(ccpaRequest_val == 'Information inquiry' && ccpaSites_val == 'LG Smart TV' || ccpaRequest_val == "information deletion" && ccpaSites_val == 'LG Smart TV'){
			$(".necessaryInfo_area").show().addClass("active");
			$(".choice_smartTv").show().addClass("active");
			$('.in-step-cluster .info-submit').attr('disabled',false);
		}
	});
	$('.otherClose').click( function() {
		$('#otherError').modal('hide');
		$('#ccpa-msg').focus();
	});
	$('.request-belt a:not([data-toggle="modal"])').click(function() {
		$('.in-step-request #btn_necessary').attr('disabled',false);		
	});
	//LGEUS-298 END
	//LGEUS-18 START
	$('#ccpa-msg').keyup(function (e){
	    var content = $(this).val();
	    checkTextLength($(document.getElementById('ccpa-msg')), $('.left-text .count'));
	});
	//LGEUS-18 END
	$('.ccpa .field-btn-area button[type=submit]').on('click', function(e) {
		$('.ccpa .field-btn-area button[type=submit]').attr('disabled',true);
		var action = $('#signinForm').attr('action');
		var email = $('#signinForm input[name="email"]').val();
		var requestVerificationToken = $('#signinForm input[name="requestVerificationToken"]').val();
		var captcha = $('input[name="captchaCodeTextBox"]').val();
		var LBD_VCID_customizedCaptcha = $('input[name="LBD_VCID_customizedCaptcha"]').val();
		var getCodeCollection = $('input[name="getCodeCollection"]').val();
		if(!$.trim(email)){
			$('#signinForm .error-msg').css('display', 'block');
			$('#signinForm .error-msg .required').css('display', 'block');
			$('#signinForm .error-msg .invalid').css('display', 'none');
			$('.ccpa .field-btn-area button[type=submit]').attr('disabled',false);
			/* LGEUS-268 20200326 add */
			$('#signinForm input[name="email"]').checkValidation();
			/* // LGEUS-268 20200326 add */
			return;
		}else{
			$('#signinForm .error-msg').css('display', 'none');
		}
		var regex = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
		if(!regex.test(email)) {
			$('#signinForm .error-msg').css('display', 'block');
			$('#signinForm .error-msg .required').css('display', 'none');
			$('#signinForm .error-msg .invalid').css('display', 'block');
			$('.ccpa .field-btn-area button[type=submit]').attr('disabled',false);
			/* LGEUS-268 20200326 add */
			$('#signinForm input[name="email"]').checkValidation();
			/* // LGEUS-268 20200326 add */
			return;
		}else{
			$('#signinForm .error-msg').css('display', 'none');
		}
		if(!$.trim(captcha)){
			$('.captcha-wrap .error-msg').css('display', 'block');
			$('.captcha-wrap .error-msg .required').css('display', 'block');
			$('.ccpa .field-btn-area button[type=submit]').attr('disabled',false);
			/* LGEUS-268 20200326 add */
			$('#captchaCodeTextBox').checkValidation();
			/* // LGEUS-268 20200326 add */
			
			return;
		}else{
			$('.captcha-wrap .error-msg').css('display', 'none');
		}
		
		var param = {'email':email,'requestVerificationToken':requestVerificationToken,'captchaCodeTextBox':captcha,'LBD_VCID_customizedCaptcha':LBD_VCID_customizedCaptcha,'getCodeCollection':getCodeCollection};
		ajax.call(action, param, 'json', function(data){
			if(!data.result){
				$('#modal_ccpa_validate_fail').modal('show');
				$('.ccpa .field-btn-area button[type=submit]').attr('disabled',false);
				return;
			}
			if(!data.captchaResult){
				$('.captcha-wrap .error-msg').css('display', 'block');
				$('.captcha-wrap .error-msg .required').css('display', 'none');
				$('.captcha-wrap .error-msg .ajax-msg').css('display', 'block');
				$('.captcha-wrap .error-msg .ajax-msg').text(data.error.captchaCodeTextBox);
				$('.ccpa .field-btn-area button[type=submit]').attr('disabled',false);
				return;
			}
			if(data.redirectUrl){
				$('#modal_ccpa_validate_suc').modal('show');
				$('#modal_ccpa_validate_suc .modal-footer button').on('click',function(e){
					location.href=data.redirectUrl;  
				});
			}else{
				$('.ccpa .field-btn-area button[type=submit]').attr('disabled',false);
			}
			
		});
	});
	
	$('.ccpa-authentication .field-block button[type=submit]').on('click', function(e) {
		$('.ccpa-authentication .field-block button[type=submit]').attr('disabled',true);
		var authCode = $('.ccpa-authentication input[id="txtBoxEmail"]').val();
		if(!$.trim(authCode)){
			$('.ccpa-authentication .error-msg').css('display', 'block');
			$('.ccpa-authentication .error-msg .required').css('display', 'block');
			$('.ccpa-authentication .error-msg .invalid').css('display', 'none');
			$('.ccpa-authentication .field-block button[type=submit]').attr('disabled',false);
			/* LGEUS-268 20200326 add */
			$('#signinForm input[name="email"]').checkValidation();
			/* // LGEUS-268 20200326 add */
			return;
		}else{
			$('.ccpa-authentication .error-msg').css('display', 'none');
		}
		var param = {'authCode':authCode};
		var action = $('#signinForm').attr('action');
		ajax.call(action, param, 'json', function(data){
			if(!data.result){
				$('#modal_ccpa_validate_fail').modal('show');
				$('.ccpa-authentication .field-block button[type=submit]').attr('disabled',false);
				return;
			}
			if(!data.authResult){
				$('.ccpa-authentication .error-msg').css('display', 'block');
				$('.ccpa-authentication .error-msg .required').css('display', 'none');
				$('.ccpa-authentication .error-msg .invalid').css('display', 'block');
				$('.ccpa-authentication .field-block button[type=submit]').attr('disabled',false);
				/* LGEUS-268 20200326 add */
				$('#signinForm input[name="email"]').checkValidation();
				/* // LGEUS-268 20200326 add */
				return;
			}else{
				$('.ccpa-authentication .error-msg').css('display', 'none');
			}
			if(data.redirectUrl){
				//$('#modal_ccpa_validate_suc').modal('show');
				location.href=data.redirectUrl;  
			}else{
				$('.ccpa-authentication .field-block button[type=submit]').attr('disabled',false);
			}
		});
	});
	
	$('.ccpa-authentication .field-block button[class=link-text]').on('click', function(e) {
		var action = '/us/authCodeResend.lgajax';
		var param = {};
		$.ajax({
			type: 'post',
			url: action,
			async: false,
			dataType: 'json',
			data: param,
			success: function(data) {
				if(data.result == false) {
					$('#modal_ccpa_validate_fail').modal('show');
				}else if(data.result != false) {
					$('#modal_ccpa_validate_suc').modal('show');
					$('.ccpa-authentication .error-msg').css('display', 'none');
				}
			},
			error: function(request,status,error) {
				console.log("status: "+status);
				console.log("error: "+error);
				result = false;
			}
		});
	});
	//LGEUS-268 Start
	$('#policyAgree').click(function(){
		var $this = $(this);
		$this.attr('aria-checked',$this.prop('checked'));
	});
	//LGEUS-268 End
	var form = {
			el: document.getElementById('inquirytoBuyForm')
	}
	function validateFile(obj) {
		// check file size
		var maxSize = obj.data('max'),
			extension = obj.data('extension'), // 허용되는 파일 확장자 목록, |로 구분 되어 있음 
			filesize = 0,
			browser=navigator.appName,
			file = obj.get(),
			ext,
			fileExtension,
			isOk=true,
			$fieldBlock = obj.closest('.field-block'),
			$error = $fieldBlock.find('.error-msg');

			$fieldBlock.removeClass('error');
			$error.hide().find('>span').hide();
		if(maxSize.indexOf('MB')!=-1) {
			maxSize=parseInt(maxSize.split('MB')[0])*1024*1024;
		}
		if(window.FileReader){
			fileSize = obj[0].files[0].size;
			ext = obj[0].files[0].name;
		} else {
			var fileobj = new ActiveXObject("Scripting.FileSystemObject");
			fileSize = fileobj.getFile( file.value ).size;
			ext = obj.val().split('/').pop().split('\\').pop();
		}
		// Check file size
		if(fileSize>maxSize) {
			isOk = false;
			$fieldBlock.addClass('error');
			$error.show().find('>span').hide();
			$error.find('>span.file-size-over').show();
		}

		// Check file extension
		fileExtension = ext.split('.')[ext.split('.').length-1].toLowerCase();
		// console.log(extension, fileExtension);
		if($.inArray(fileExtension, extension.split('|')) == -1) {
			isOk = false;
			$fieldBlock.addClass('error');
			$error.show().find('>span').hide();
			$error.find('>span.not-fit-type').show();
		}
	}
	$(form.el).find('input:file').on({
		change: function(e){
			e.preventDefault();
			if(e.currentTarget.files[0]) {
				validateFile($(this));
			}
		}
	});
	$('.ccpa-form .field-btn-area button[type=submit]').on('click', function(e) {
		$('.ccpa-form .field-btn-area button[type=submit]').attr('disabled',true);
		if($('#inquirytoBuyForm').checkValidation()){
			$(form.el).find('input:file').each(function(i){
				if($(this).get(0).files[0]) {
					validateFile($(this));
				}
			})
			if(!$(form.el).find('input:file').closest('.field-block').hasClass('error')){
				/*if(!$("#ccpa-request").val()){ 
					$("#ccpa-request").siblings(".error-msg").css("display", "block");
					$('.ccpa-form .field-btn-area button[type=submit]').attr('disabled',false);
					 LGEUS-268 20200330 add 
					$('#ccpa-request').checkValidation();
					// LGEUS-268 20200330 add 
					return false;
				}else{
					$("#ccpa-request").siblings(".error-msg").css("display", "none");
				}
				if(!$("#ccpa-sites").val()){ 
					$("#ccpa-sites").siblings(".error-msg").css("display", "block");
					$('.ccpa-form .field-btn-area button[type=submit]').attr('disabled',false);
					 LGEUS-268 20200330 add 
					$('#ccpa-sites').checkValidation();
					 // LGEUS-268 20200330 add 
					return false;
				}else{
					$("#ccpa-sites").siblings(".error-msg").css("display", "none");
				}
				var message = $('.intext-area.active #ccpa-msg').val();
				if(!$.trim(message)&& typeof message!=='undefined'){
					$('.intext-area.active #ccpa-msg').siblings(".error-msg").css("display", "block");
					$('.ccpa-form .field-btn-area button[type=submit]').attr('disabled',false);
					 LGEUS-268 20200326 add 
					$('.intext-area.active #ccpa-msg').checkValidation();
					 // LGEUS-268 20200326 add 
					 return false;
				}else{
					$('.intext-area.active #ccpa-msg').siblings(".error-msg").css("display", "none");
				}
				
				if(!$('input[name="policyAgree"]').prop('checked')){
					$('.agree-check .error-msg').css('display', 'block');
					$('.ccpa-form .field-btn-area button[type=submit]').attr('disabled',false);
					 LGEUS-268 20200326 add 
					$('input[name="policyAgree"]').checkValidation();
					 // LGEUS-268 20200326 add 
					return false;
				}else{
					$('.agree-check .error-msg').css('display', 'none');
				}*/
				
				
				var param = $('#inquirytoBuyForm').serializeArray();
				var action = $('#inquirytoBuyForm').attr('action');
				var params = new FormData();
				var curParams = $(form.el).serializeArray();
				for (var i = 0; i < curParams.length; i++) {
					fieldValue = form.el[curParams[i].name].value;
		
					if(form.el[curParams[i].name].length > 0) {
						var options = form.el[curParams[i].name];
							fieldValue = [];
						if(options.type !== undefined) {
							if(options.type.indexOf('select') >= 0) {
								fieldValue = options.options[options.selectedIndex].value;
								// console.log(fieldValue);
							}
						}else {
							for (var optionIdx = 0; optionIdx < options.length; optionIdx++) {
								var currentOpt = options[optionIdx];
								if(currentOpt.checked == true) {
									fieldValue += currentOpt.value;
								}
							}
						}
						
					}
					params.append(curParams[i].name, fieldValue);
				}
				$files = $(form.el).find('input:file');
				if($files.length > 0) {
					for (var j = 0; j < $files.length; j++) {
							var _file = $files.eq(j).get(0);
							if(_file.files[0]) {
								 //console.log(_file.name, _file.files[0]);
								params.append(_file.name, _file.files[0], _file.files[0].name);
							}
						}
				}

				ajax.noCacheCall(action, params, 'json', function(data){
					if(!data.result){
						$('#modal_ccpa_validate_fail').modal('show');
						$('.ccpa-form .field-btn-area button[type=submit]').attr('disabled',false);
						return;
					}
					if(data.redirectUrl){
						location.href=data.redirectUrl;  
					}else{
						$('.ccpa-form .field-btn-area button[type=submit]').attr('disabled',false);
					}
				})
				/*ajax.call(action, param, 'json', function(data){
					if(!data.result){
						$('#modal_ccpa_validate_fail').modal('show');
						$('.ccpa-form .field-btn-area button[type=submit]').attr('disabled',false);
						return;
					}
					if(data.redirectUrl){
						location.href=data.redirectUrl;  
					}else{
						$('.ccpa-form .field-btn-area button[type=submit]').attr('disabled',false);
					}
				});*/
			}
		}else{
			$('.ccpa-form .field-btn-area button[type=submit]').attr('disabled',false);
		}
	});
});
